import script from "./ArticleCartForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleCartForm.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleCartForm.vue?vue&type=style&index=0&id=8a1728fc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a1728fc"]])

export default __exports__